import { useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useFirstMountState } from 'react-use'

import { useDocs } from '../../store'
import context from './context'
import {
  StepsProviderInterface,
  StepsProviderType,
  LocationStateType,
} from './interface'

const { Provider } = context

const IS_LOCAL = process.env.REACT_APP_ENV === 'local'

const StepsProvider = ({ children }: StepsProviderInterface): JSX.Element => {
  const isFirstMount = useFirstMountState()
  const { registerId } = useDocs()
  const navigate = useNavigate()
  const { state } = useLocation() as { state: LocationStateType }
  const search = useLocation().search
  const skipStep = new URLSearchParams(search).get('skipStep')

  let stateStep = state?.step ?? 1

  if (skipStep) stateStep = Number(skipStep) + 1

  const currentStep = useMemo(
    () => (isFirstMount && !skipStep ? 1 : stateStep),
    [isFirstMount, state?.step]
  )

  const goStep = (step: number) => {
    let url = `/envio-documentacao/${registerId}`
    if (IS_LOCAL) url = `/${registerId}`

    navigate(url, { state: { step } })
  }

  const value: StepsProviderType = {
    step: currentStep,
    skipStep: !!skipStep,
    goStep,
  }

  return <Provider value={value}>{children}</Provider>
}

export default StepsProvider
